import { useTranslations } from 'utils';
import { ReactComponent as BankTransfer } from './bank-transfer-grey.svg';
import { ReactComponent as RetryVector } from './retry-vector.svg';

const RecurringInfo = ({ recurring }: { recurring: boolean }) => {
  const i18n = useTranslations();
  if (recurring === undefined) {
    return null;
  }
  const Icon = recurring ? RetryVector : BankTransfer;
  const labelMessageKey = recurring
    ? 'installments.autoPay'
    : 'installments.manualPay';

  return (
    <div
      className="flex items-center justify-end gap-2"
      data-testid="recurringInfo"
    >
      <span>
        <Icon />
      </span>
      <span className="text-sm text-gray-700">{i18n.t(labelMessageKey)}</span>
    </div>
  );
};

export { RecurringInfo };
